/** Roles that can invite, approve pending users, and change team member roles. */
export const USER_MGMT_CAN_MANAGE = [
  'superadmin',
  'admin',
  'hod',
  'manager',
  'marketing_manager',
  'analyst',
  'product',
  'product_manager',
  'lead',
];

/** Department stewards who may adjust their own role within this set only. */
export const SELF_SERVICE_STEWARD_ROLES = [
  'hod',
  'manager',
  'marketing_manager',
  'analyst',
  'product_manager',
  'product',
  'lead',
];

export function canManageUsers(role) {
  return USER_MGMT_CAN_MANAGE.includes(String(role || '').toLowerCase());
}

export function isSelfServiceSteward(role) {
  return SELF_SERVICE_STEWARD_ROLES.includes(String(role || '').toLowerCase());
}
